module.exports = "img/4.77a042.webp";